import { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { merge_query, replace_search } from './url_query';

// The URL's filters, parsed once on mount (a later address-bar edit never re-seeds them).
export const useInitialQuery = (parse) => {
  const location = useLocation();
  const [initial] = useState(() => parse(location.search));
  return initial;
};

// Keeps the URL in step with `values` via replace (a filter change is not a history step).
export const useQueryMirror = (keys, values) => {
  const history = useHistory();
  const location = useLocation();
  const latest = useRef({ keys, values });
  latest.current = { keys, values };
  const next = merge_query(location.search, keys, values);
  useEffect(() => {
    const { keys: k, values: v } = latest.current;
    replace_search(history, location.pathname, (s) => merge_query(s, k, v));
  }, [next, history, location.pathname, location.search]);
};
